import { ICON_TYPE, InfoView as InfoViewComponent } from './InfoView';
import { withContainer } from './withContainer';

const InfoView = withContainer(InfoViewComponent);

export {
  ICON_TYPE,
  InfoView,
  InfoViewComponent,
};
export * from './withContainer';
